import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, PhoneIcon } from 'lucide-react';
export function ReviewCTA() {
  return <section className="py-12 md:py-16 bg-warm-brown text-cream relative overflow-hidden" data-id="element-382">
      {/* Subtle background texture */}
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/1R6hUwZoQpV1Q9E5wtoWab/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinforci.jpg')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-383"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-384">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-0 md:divide-x divide-cream/20" data-id="element-385">
          {/* Left Column: Review */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="md:pr-12 flex flex-col items-start" data-id="element-386">
            <div className="flex items-center gap-1 mb-4" data-id="element-387">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-388" />)}
            </div>

            <h2 className="font-display italic text-4xl md:text-5xl mb-4" data-id="element-389">
              Love your new look?
            </h2>

            <p className="text-base text-cream/80 font-body mb-8 max-w-md" data-id="element-390">
              We'd love to hear about your experience! Leave us a review on
              Google and help other women find their perfect crown.
            </p>

            <a href="https://share.google/yW0RVXXsvmWqPnNHq" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 bg-brand-gold text-cream font-bold uppercase tracking-widest text-xs rounded-full hover:bg-near-black transition-colors shadow-lg" data-id="element-391">
              Leave a Review
            </a>
          </motion.div>

          {/* Right Column: Phone Promo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="md:pl-12 flex flex-col items-start md:items-end md:text-right" data-id="element-392">
            <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center mb-4" data-id="element-393">
              <PhoneIcon className="w-5 h-5 text-brand-gold" data-id="element-394" />
            </div>

            <h2 className="font-display italic text-4xl md:text-5xl mb-4" data-id="element-395">
              Ready to book?
            </h2>

            <p className="text-base text-cream/80 font-body mb-2 max-w-md" data-id="element-396">
              Call us directly to schedule your next appointment or ask any
              questions about our styles.
            </p>

            <a href="tel:2409217857" className="font-display text-4xl md:text-5xl text-brand-gold hover:text-cream transition-colors mb-8 block" data-id="element-397">
              (240) 921-7857
            </a>

            <a href="tel:2409217857" className="inline-flex items-center justify-center px-8 py-3 bg-brand-gold text-cream font-bold uppercase tracking-widest text-xs rounded-full hover:bg-near-black transition-colors shadow-lg" data-id="element-398">
              Call Now
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}